import styled from "styled-components";

export const CustomTablePaginationContainer = styled.div`
  padding: 0 14px;
  background-color: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: flex-end;
`;
